import { render, staticRenderFns } from "./component-download.vue?vue&type=template&id=52cd5b0e&scoped=true&"
import script from "./component-download.vue?vue&type=script&lang=js&"
export * from "./component-download.vue?vue&type=script&lang=js&"
import style0 from "./component-download.vue?vue&type=style&index=0&id=52cd5b0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cd5b0e",
  null
  
)

export default component.exports